var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArtistIcon = function SvgArtistIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.668.743A12.74 12.74 0 0 0 4.412 2.077a10.255 10.255 0 0 0-4.29 9.635C.885 15.571 4.686 18 9.815 16.591c5.531-1.518 6.869-4.766 6.69-5.593s-2.8-1.734-1.8-3.669c1.245-2.425 3.28-1.206 4.181-1.7s.56-3.612-3.216-4.883Zm-7.66 1.412a13.382 13.382 0 0 0-2.742 1.286 8.168 8.168 0 0 0-3.014 3.837.324.324 0 1 1-.6-.244 8.7 8.7 0 0 1 3.267-4.133 13.982 13.982 0 0 1 2.874-1.357.322.322 0 1 1 .2.611Zm3.837 9.815a1.582 1.582 0 1 1 1.1-1.93 1.578 1.578 0 0 1-1.1 1.93Z"
  })));
};
export default SvgArtistIcon;